import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Trash2, UserPlus } from "lucide-react";

const EMPTY = { name: "", designation: "", identifier: "" };

export default function ESignSignatoriesTab() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const load = useCallback(async () => {
    const r = await api.get("/esign/signatories");
    setRows(r.data || []);
  }, []);
  useEffect(() => { load().catch(() => {}); }, [load]);

  const err = (e) => toast.error(e?.response?.data?.detail || "Action failed");
  const add = async () => {
    try { await api.post("/esign/signatories", form); setForm(EMPTY); toast.success("Signatory added"); load(); } catch (e) { err(e); }
  };
  const toggle = async (s) => {
    try { await api.put(`/esign/signatories/${s.id}`, { ...s, active: !s.active }); load(); } catch (e) { err(e); }
  };
  const remove = async (s) => {
    try { await api.delete(`/esign/signatories/${s.id}`); load(); } catch (e) { err(e); }
  };
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <Card className="p-4 rounded-sm space-y-4" data-testid="esign-signatories-tab">
      <div>
        <div className="font-medium">Authorised eSign signatories</div>
        <p className="text-xs text-muted-foreground">People allowed to Aadhaar-eSign this company's documents. The email or mobile receives the signing link.</p>
      </div>
      <div className="grid md:grid-cols-4 gap-2">
        <Input value={form.name} onChange={set("name")} placeholder="Full name (as on Aadhaar)" className="rounded-sm" data-testid="signatory-name-input" />
        <Input value={form.designation} onChange={set("designation")} placeholder="Designation e.g. Director" className="rounded-sm" data-testid="signatory-designation-input" />
        <Input value={form.identifier} onChange={set("identifier")} placeholder="Email or mobile" className="rounded-sm" data-testid="signatory-identifier-input" />
        <Button onClick={add} disabled={!form.name || !form.identifier} className="rounded-sm gap-1.5" data-testid="signatory-add-btn">
          <UserPlus className="w-3.5 h-3.5" /> Add signatory
        </Button>
      </div>
      <div className="divide-y border rounded-sm">
        {rows.map((s) => (
          <div key={s.id} className="flex items-center justify-between p-2 text-sm" data-testid={`signatory-row-${s.id}`}>
            <div><b>{s.name}</b> <span className="text-muted-foreground">{s.designation}</span> <span className="font-mono text-xs ml-2">{s.identifier}</span></div>
            <div className="flex items-center gap-3">
              <Switch checked={s.active} onCheckedChange={() => toggle(s)} data-testid={`signatory-active-${s.id}`} />
              <Button size="icon" variant="ghost" onClick={() => remove(s)} data-testid={`signatory-delete-${s.id}`}><Trash2 className="w-4 h-4" /></Button>
            </div>
          </div>
        ))}
        {!rows.length && <div className="p-4 text-xs text-muted-foreground text-center" data-testid="signatory-empty">No signatories yet.</div>}
      </div>
    </Card>
  );
}
